(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cpo-main-collection-product-grid"]) return;
  try {
    
	class MenuDrawer extends HTMLElement {
		constructor() {
			super();

			this.mainDetailsToggle = this.querySelector('details');

			this.addEventListener('keyup', this.onKeyUp.bind(this));
			this.addEventListener('focusout', this.onFocusOut.bind(this));
			this.bindEvents();
		}

		bindEvents() {
			this.querySelectorAll('summary').forEach((summary) =>
				summary.addEventListener('click', this.onSummaryClick.bind(this))
			);
			this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
				button.addEventListener('click', this.onCloseButtonClick.bind(this))
			);
		}

		onKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			const openDetailsElement = event.target.closest('details[open]');
			if (!openDetailsElement) return;

			openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement);
		}

		onSummaryClick(event) {
			const summaryElement = event.currentTarget;
			const detailsElement = summaryElement.parentNode;
			const parentMenuElement = detailsElement.closest('.has-submenu');
			const isOpen = detailsElement.hasAttribute('open');
			const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

			function addTrapFocus() {
				trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
				summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
			}

			if (detailsElement === this.mainDetailsToggle) {
				if (isOpen) event.preventDefault();
				isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

				if (window.matchMedia('(max-width: 990px)')) {
					document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
				}
			} else {
				setTimeout(() => {
					detailsElement.classList.add('menu-opening');
					summaryElement.setAttribute('aria-expanded', true);
					parentMenuElement && parentMenuElement.classList.add('submenu-open');
					!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
				}, 100);
			}
		}

		openMenuDrawer(summaryElement) {
			setTimeout(() => {
				this.mainDetailsToggle.classList.add('menu-opening');
			});
			summaryElement.setAttribute('aria-expanded', true);
			trapFocus(this.mainDetailsToggle, summaryElement);
			document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
		}

		closeMenuDrawer(event, elementToFocus = false) {
			if (event === undefined) return;

			this.mainDetailsToggle.classList.remove('menu-opening');
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open');
				details.classList.remove('menu-opening');
			});
			this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
				submenu.classList.remove('submenu-open');
			});
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);

			if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
		}

		onFocusOut() {
			setTimeout(() => {
			if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
				this.closeMenuDrawer();
			});
		}

		onCloseButtonClick(event) {
			const detailsElement = event.currentTarget.closest('details');
			this.closeSubmenu(detailsElement);
		}

		closeSubmenu(detailsElement) {
			const parentMenuElement = detailsElement.closest('.submenu-open');
			parentMenuElement && parentMenuElement.classList.remove('submenu-open');
			detailsElement.classList.remove('menu-opening');
			detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
			removeTrapFocus(detailsElement.querySelector('summary'));
			this.closeAnimation(detailsElement);
		}

		closeAnimation(detailsElement) {
			let animationStart;

			const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute('open');
				if (detailsElement.closest('details[open]')) {
					trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
				}
			}
			};

			window.requestAnimationFrame(handleAnimation);
		}
	}

	customElements.define('menu-drawer', MenuDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-contact-form"] && !Shopify.designMode) return;
  try {
    
	class RlxSendMessage extends HTMLElement {
		constructor() {
			super();
			this.init()
		}

		init(){
			const dataStores = RlxStores;
			const fieldEmail = this.querySelector('#email');
			const fieldPhone = this.querySelector('#phone');
			const fieldPrivacy = this.querySelector('#privacy');
			const selectCity = this.querySelector('#retailerCity');
			const selectAddress = this.querySelector('#retailerAddress');
			const submitButton = this.querySelector('button[type=submit]');

			if (window.location.search === '?contact_posted=true') {
				this.showSuccessMessage();
				this.scrollTo(this.querySelector('#form_successfully'));
			}

			this.querySelector('#contact-form-next').addEventListener('click',  () =>{
				this.showContactForm(true);
				this.querySelector('#hidden-message').value = this.querySelector('#contact-form-message').value;
			});

			selectCity.addEventListener('change', () =>{
				const optionValue = event.currentTarget.value;
				const selectedStore = dataStores.filter((item) =>{
					return item.title === optionValue;
				});
				this.changeSelectedAddress(selectedStore[0].address);
			});

			selectAddress.addEventListener('change', () =>{
				const optionValue = event.currentTarget.value;
				const selectedStore = dataStores.filter((item) =>{
					return item.address === optionValue;
				});
				this.changeSelectedCity(selectedStore[0].title);
			});		

			fieldPrivacy.addEventListener('click', () =>{
				const checkBoxPrivacy = event.currentTarget;
				if(checkBoxPrivacy.checked){
					checkBoxPrivacy.classList.remove('!bg-transparent');
					checkBoxPrivacy.classList.add('!bg-rolex-green');
					checkBoxPrivacy.nextElementSibling.classList.remove('fill-transparent');
					checkBoxPrivacy.nextElementSibling.classList.add('fill-white');
				}else{
					checkBoxPrivacy.classList.add('!bg-transparent');
					checkBoxPrivacy.classList.remove('!bg-rolex-green');
					checkBoxPrivacy.nextElementSibling.classList.add('fill-transparent');
					checkBoxPrivacy.nextElementSibling.classList.remove('fill-white');					
				}
			});

            submitButton.addEventListener('click', (event) => {
                event.preventDefault(); 

                this.removeErrorMsg();

                const isFieldEmpty = this.isFieldEmpty(
                    [fieldEmail]
                );

                if(isFieldEmpty) return;

                const isEmailValid = this.isEmailValid(fieldEmail);
                if(!isEmailValid) return;

                const isFieldUnchecked = this.isUnhecked(fieldPrivacy);
                if(isFieldUnchecked) return;

                this.sendForm();
            });			
		}

		changeSelectedAddress(address){
			this.querySelector('#retailerAddress').value = address;
		}

		changeSelectedCity(city){
			this.querySelector('#retailerCity').value = city;
		}		

		showContactForm(value){
			this.firstForm = this.querySelector('#contact-form-first');
			this.secondForm = this.querySelector('#contact-form-second');

			if(value === true){
				this.firstForm.classList.add('!hidden');
				this.secondForm.classList.remove('!hidden');
			}else{
				this.firstForm.classList.remove('!hidden');
				this.secondForm.classList.add('!hidden');
			}
		}	

		showSuccessMessage(){
			this.querySelector('#contact-form-first').classList.add('!hidden');
			this.querySelector('#contact-form-second').classList.remove('!hidden');
			this.querySelector('#form_content').classList.add('!hidden');
		}		

		scrollTo(elementID){
			this.offsetElement = elementID.getBoundingClientRect()
			window.scrollTo({
				top: this.offsetElement.top,
				behavior: "smooth"
			});			
		}

        isFieldEmpty(fields){
            let existFieldEmpty = false;
        
            for (const field of fields) {
                if(field.value === ''){
                    existFieldEmpty = true;
                    this.showErrorMsg(field);
                }
            }
            return existFieldEmpty;
        }

        isEmailValid(field) {
            const email = field.value;
            var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            if (!regex.test(email)) {
              this.showErrorMsg(field);
            } else {
              return regex.test(email);				
            }
        }

        isUnhecked(field){
            let unchecked = false;
        
			if(field.checked === false){
				unchecked = true;
				this.showErrorMsg(field);
			}
            return unchecked;
        }

        showErrorMsg(field){
            const elementError = document.createElement('p');
            const messageError = field.getAttribute('data-error');
            elementError.classList.add('msg-error', 'relative', 'text-[13px]', 'font-bold', 'text-red-700');
            elementError.innerHTML = messageError;
            field.closest('.form__field').append(elementError);

			if(field.getAttribute('id') === 'phone'){
				const elementBlank = document.createElement('p');
				elementBlank.classList.add('msg-error', 'relative', 'text-[13px]', 'font-bold', 'text-red-700');
				elementBlank.innerHTML = '&nbsp;';
				this.querySelector('#PhoneCode').closest('.form__field').append(elementBlank);
			}
        }

        removeErrorMsg(){
            const msgsError = this.querySelectorAll('.msg-error');
            msgsError.forEach((item) => {
                item.remove();
            });
        }

        sendForm(){
            this.querySelector('form').submit();
			_satellite.track("contactForm");
        }		
	}
	customElements.define('rlx-send-message', RlxSendMessage);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-footer"] && !Shopify.designMode) return;
  try {
    
	class RlxFooter extends HTMLElement {
		constructor() {
			super();
			this.init()
		}

		init(){
			document.querySelector('.back-top').addEventListener('click', () => {
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			});
		}	
	}
	customElements.define('rlx-footer', RlxFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-header"] && !Shopify.designMode) return;
  try {
    
	class RlxHeader extends HTMLElement {
		constructor() {
			super();

			this.init()
		}

		init(){
			this.nav = document.querySelector('.header-nav');
			this.navMobile = document.querySelector('.rlx-menu-button');
			this.wrapperNav = document.querySelector('.header-wrapper-nav');
			this.linkMenuMobile = document.querySelector('.rlx-menu-button'); 

			var navWidth = this.nav.getBoundingClientRect().width
			var wrapperNavWidth = this.wrapperNav.getBoundingClientRect().width;

			if(navWidth >= wrapperNavWidth){
				this.showBurgerMenu(true);
			} else {
				this.showBurgerMenu(false);
			}

			window.addEventListener("resize", () =>{
				navWidth = this.nav.getBoundingClientRect().width
				wrapperNavWidth = this.wrapperNav.getBoundingClientRect().width;

				if(navWidth >= wrapperNavWidth){
					this.showBurgerMenu(true);
				} else {
					this.showBurgerMenu(false);
				}
			});			

			this.linkMenuMobile.addEventListener('click', () => {
				this.toggleMenuMobile();
			});
		}

		showBurgerMenu(value){
			if(value === true){
				this.navMobile.classList.remove('md:hidden');
				this.nav.classList.remove('md:visible');
			}else{
				this.navMobile.classList.add('md:hidden');
				this.nav.classList.add('md:visible');
			}
		}

		toggleMenuMobile(){
			this.menuMobile = document.querySelector('.rlx-menu-mobile');
			this.menuMobile.classList.toggle('invisible');
		}		
	}
	customElements.define('rlx-header', RlxHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-products-grid"] && !Shopify.designMode) return;
  try {
    
	class RlxProductGrid extends HTMLElement {
		constructor() {
			super();

			this.init()
		}

		init(){
			console.log('init')
			this.showMore = document.querySelector('.show-more');
			this.cardItems = document.querySelectorAll('.rlx-product-card');

			this.showMore.addEventListener('click', () => {
				this.showAllProducts();
			});
		}

		showAllProducts(){
			this.cardItems.forEach((item) =>{
				item.classList.remove('hidden');
			});
			this.showMore.classList.add('hidden');
		}		
	}
	customElements.define('rlx-product-grid', RlxProductGrid);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rlx-products-list-grid"] && !Shopify.designMode) return;
  try {
    
	class RlxProductsListGrid extends HTMLElement {
		constructor() {
			super();
			this.init()
		}

		init(){
			//console.log('init')
			this.showMore = document.querySelector('.show-more');
			this.cardItems = document.querySelectorAll('.rlx-product-card');
			if ( this.showMore ) {
				this.showMore.addEventListener('click', () => {
					this.showAllProducts();
				});
			}
		}

		showAllProducts(){
			this.cardItems.forEach((item) =>{
				item.classList.remove('hidden');
			});
			this.showMore.classList.add('hidden');
		}		
	}
	customElements.define('rlx-products-list-grid', RlxProductsListGrid);

  } catch(e) { console.error(e); }
})();
})();
